import axios from "src/service/axios_c";
import $ from "jquery";
import System from "../helper/system";
import store from "../storeWire";
import storeInUse from "../storeWire";
import Product from "@system/config/product";
import Auth from "@system/config/auth";
import PayloadMaker from "./ProductListingAPICall/payloadMaker";
import ResponseMaker from "./ProductListingAPICall/responseMaker";
import {
    set_append_facade_options_status,
    set_category_filter_applied_status,
    set_to_master_data_only_products_list
} from "../store/slice/model/ProductListing";
import { __remove, __set } from "src/store/axios_indicator";
import { isArray, isString } from "underscore";
import EssentialContentAPICall from "./EssentialContentAPICall";
import Helper from "src/support/Helper";

class ProductListingAPICall {
    getProductsForProductListingPageList = async (page = false, limit = false, extra = {}) => {
        extra.isSkipFacets = false;
        // extra.isDesignsRequired = true; // 14567 - remove design flag

        return await this.getList(page, limit, extra, true);
    };
    getGroupList = async (search, searchFilterBasedOnManufacturer = false, ERPPartNumber = false, onlyGroup = false) => {
        __set('PRODUCT_MANUAL_SEARCH_LISTING_API_CALL');
        let isDetailSearch = false;
        let filter = '';
        if (searchFilterBasedOnManufacturer) {
            filter = "ManufacturerName eq '" + searchFilterBasedOnManufacturer + "'";
            isDetailSearch = true;
        }
        // Group call pass ERPMFRPartNumber
        if (onlyGroup && filter.trim() !== '') {
            filter += " and ERPMFRPartNumber eq '" + search + "'";
        }
        let SboatF = Auth.getAuthSBoat();
        if (filter) {
            filter += " and Sboat eq '" + SboatF + "'";
        } else {
            filter += "Sboat eq '" + SboatF + "'";
        }
        if (ERPPartNumber && isArray(ERPPartNumber)) {
            isDetailSearch = true;
            ERPPartNumber.map((v) => {
                filter += 'ERPPartNumber' + ' eq ' + v + ' or ';
            });
            filter = filter.trim().substring(0, filter.length - 4);
        }
        let res = {};
        /**
         * Ticket    : 9301
         * Change    : Remove Regex expression and pass plain text in search param for manual & product search
         * Change by : Pankaj
         * Date      : 22 Feb 2023
         */
        if (search.length > 0) {
            let config = {
                method: 'POST',
                url: Product.PRODUCT_GROUPED_LISTING,
                headers: Helper.getCommonHeader('POST'),
                data: {
                    filter,
                    isDetailSearch,
                    search: onlyGroup ? '*' : search, // Remove asterisk (*) when click on product having count > 1
                }
            };
            await axios(config).then((resIn) => {
                if (resIn?.data?.Data !== undefined) {
                    res = resIn.data.Data;
                }
            });
        }
        __remove('PRODUCT_MANUAL_SEARCH_LISTING_API_CALL');
        return res;
    };

    getList = async (page = false, limit = false, extra = {}, enable_get_url_param_edit = false, isForAutoSuggest = false) => {
        let c = System.getParams()
        if (extra.skipURLParams !== undefined && extra.skipURLParams === true) {
            c = {}
        }

        let search = '';
        try {
            if (c.search !== undefined) {
                search = c.search;
            }
        } catch (e) {
        }
        try {
            if (page === false && c.page !== undefined) {
                page = c.page;
            }
        } catch (e) {
        }
        try {
            if (limit === false && c.limit !== undefined) {
                limit = c.limit;
            }
        } catch (e) {
        }

        let searchColumnArr = []
        try {
            if (c.searchColumn) {
                let res = atob(c.searchColumn)
                if (res) {
                    searchColumnArr = JSON.parse(res);
                }
            }
        } catch (e) {
            searchColumnArr = null;
        }

        if (page === false) {
            page = 1;
        }
        if (limit === false) {
            limit = 10;
        }
        if (extra.search !== undefined) {
            search = extra.search
        }
        let last_page = page - 1;
        let skip = limit * last_page;
        if (skip === null) {
            skip = 0;
        }
        if (!skip) {
            skip = 0;
        }
        if (skip === '') {
            skip = 0;
        }
        if (skip < 0) {
            skip = 0;
        }
        // DT - 10994 - 4/May - remove filter when universal search is applying
        let p_filter = this.getFilterKeyForListing(!extra.universalSearch);
        if (isString(search)) {
            search = search.trim();
        }
        let data = {
            "queryType": "full",
            "searchMode": "all",
            "search": search,
            "searchFields": "Sboat,ManufacturerPartNumber,ItemNumber,ERPPartNumber,LongDescription,ManufacturerName,FamilyName,StructureName,Attributes/AttributeValue" +
                "" +
                ",CustomerPartNumbers/CUSTOMER_PART_NUMBER",
            "facets": [
                "ManufacturerName,count:99999",
                "FamilyName,count:99999",
                "StructureName,count:99999",
                "Attributes/AttributeValue,count:99999"
            ],
            "filter": p_filter.res,
            "count": true,
            "top": limit,
            "skip": skip,
            // "isDesignsRequired": isDesignsRequired // 14567
        };
		// Performance fix for isAttributesFacetInclude
		if (p_filter?.categoryFilter_detected !== undefined) {
            data.isAttributesFacetInclude = p_filter.categoryFilter_detected;
         }

        // BOM Search Match Pop-up pass Column
        if (searchColumnArr && searchColumnArr.length > 0) {
            data['searchColumns'] = searchColumnArr;
        }

        if (!extra.orderbydirection) {
            extra.orderbydirection = "desc";
        }
        if (extra.isSkipFacets !== undefined) {
            data.isSkipFacets = extra.isSkipFacets;
        }
        c.page = page;
        c.limit = limit;
        c.orderby = extra.orderby;
        c.orderbydirection = extra.orderbydirection;
        if (enable_get_url_param_edit === true) {
            history.replaceState(null, null, "?" + $.param(c));
        }

        // Adjusting
        if (extra.orderby) {
            data.orderby = extra.orderby + " " + extra.orderbydirection + ",search.score() desc";
        } else {
            delete data.orderby;
            delete data.orderbydirection;
        }
        // For Universal Search pass order by 
        if (extra.universalSearch) {
            data.orderby = "search.score() desc, ERPMFRPartNumber asc";
        }
        const config = {
            method: 'post',
            headers: Helper.getCommonHeader('POST', 'application/json'),
            data: data,
            p_filter
        };
        return await ProductListingAPICall.axiosCallToAPI(config, isForAutoSuggest);
    };

    getSingleItemNumberByManufacturerPartNumber = async (manufacturerPartNumber) => {
        let data = {
            "filter": "ManufacturerPartNumber eq '" + manufacturerPartNumber + "' and " + "Sboat eq '" + Auth.getAuthSBoat() + "'",
            "top": 1,
            "skip": 0,
            "isIncludeCount": true,
            "isProductImageInclude": false,
            "isSkipFacets": true,
            "orderby": "ManufacturerPartNumber asc",
            "search": '*'
        };

        const config = {
            method: 'post',
            url: Product.PRODUCT_LISTING,
            headers: Helper.getCommonHeader('POST', 'application/json'),
            data: data
        };
        let res = {};
        await axios(config)
            .then(function (response) {
                if (response?.data?.Data?.Products && response.data.Data.Products.length > 0) {
                    let product = response.data.Data.Products
                    res = product[0].ItemNumber
                }
            }).catch(() => {

            });
        return res
    };

    getSingleItemNumberBySearchParam = async (searchParam) => {
        let data = {
            "filter": "Sboat eq '" + Auth.getAuthSBoat() + "'",
            "top": 1,
            "skip": 0,
            "isIncludeCount": true,
            "isProductImageInclude": false,
            "isSkipFacets": true,
            "orderby": "ManufacturerPartNumber asc",
            "search": searchParam + '*'
        };

        const config = {
            method: 'post',
            url: Product.PRODUCT_LISTING,
            headers: Helper.getCommonHeader('POST', 'application/json'),
            data: data
        };
        let res = {};
        await axios(config)
            .then(function (response) {
                if (response?.data?.Data?.Products && response.data.Data.Products.length > 0) {
                    let product = response.data.Data.Products
                    res = product[0].ItemNumber
                }
            }).catch(() => {

            });
        return res
    };

    CognitiveSearchFieldConfig = {
        FamilyName: {
            search_type: 'FamilyName'
        },
        ManufacturerName: {
            search_type: 'ManufacturerName'
        },
        flagFacets: {
            search_type: 'flagFacets'
        },
        Categories: {
            search_type: 'categories'
        }
    };

    getFieldType = (field) => {
        let search_type = 'attributes';
        if (new ProductListingAPICall().CognitiveSearchFieldConfig[field] !== undefined) {
            search_type = new ProductListingAPICall().CognitiveSearchFieldConfig[field].search_type;
        }
        return search_type;
    };
    getFilterKeyForListing = (setFilterKey = true) => {
        let res = '';
        let addedAtLeaseOneFilter = '';
        let categoryFilter_detected = false;
        let appendFacadeOptions_detected = false;
        if (System.getParams().appendFacadeOptions !== undefined) {
            appendFacadeOptions_detected = System.getParams().appendFacadeOptions;
        }
        if (setFilterKey) { // DT - 10994 - 4/May - remove filter when universal search is applying
            try {
                let e = store.getState().entities;
                let a = Object.entries(e.ProductListingFilterApplied);
                if (a.length) {
                    let attribute_filter = [];
                    let flagFacets_filter_added = '';
                    let normal_filter_added = '';
                    let FamilyName_filter_added = '';
                    let ManufacturerName_filter_added = '';
                    let categories_filter_added = '';
                    a.map((v, i) => {
                        if (v[1].selection !== undefined) {
                            v[1].selection.map((vH, iH) => {
                                if (ProductListingAPICall.validateFilterValue(vH.value)) {
                                    let search_type = 'attributes';
                                    let field = v[0];
                                    let field_name = v[1].main_label;
                                    if (this.CognitiveSearchFieldConfig[field] !== undefined) {
                                        search_type = this.CognitiveSearchFieldConfig[field].search_type;
                                    }
                                    if (search_type !== 'attributes') {
                                        let f = ProductListingAPICall.getCognitiveSearchField(field, vH.value, search_type, vH);
                                        if (f) {
                                            if (search_type === 'flagFacets') {
                                                flagFacets_filter_added = flagFacets_filter_added + f;
                                            }
                                            if (search_type === 'normal') {
                                                normal_filter_added = normal_filter_added + f;
                                            }
                                            if (search_type === 'FamilyName') {
                                                FamilyName_filter_added = FamilyName_filter_added + f;
                                            }
                                            if (search_type === 'ManufacturerName') {
                                                ManufacturerName_filter_added = ManufacturerName_filter_added + f;
                                            }
                                            if (search_type === 'categories') {
                                                categories_filter_added = categories_filter_added + f;
                                            }
                                            addedAtLeaseOneFilter = true;
                                        }
                                    }
                                    if (search_type === 'attributes') {
                                        attribute_filter.push({ attributeName: field_name, attributeValue: [vH.value] });
                                    }
                                }
                            })
                        }
                    });
                    if (flagFacets_filter_added) {
                        flagFacets_filter_added = '(' + flagFacets_filter_added.trim().substring(0, flagFacets_filter_added.length - 4) + ') and ';
                        res += flagFacets_filter_added;
                    }
                    if (normal_filter_added) {
                        normal_filter_added = '(' + normal_filter_added.trim().substring(0, normal_filter_added.length - 4) + ') and ';
                        res += normal_filter_added;
                    }
                    if (FamilyName_filter_added) {
                        FamilyName_filter_added = '(' + FamilyName_filter_added.trim().substring(0, FamilyName_filter_added.length - 4) + ') and ';
                        res += FamilyName_filter_added;
                    }
                    if (ManufacturerName_filter_added) {
                        ManufacturerName_filter_added = '(' + ManufacturerName_filter_added.trim().substring(0, ManufacturerName_filter_added.length - 4) + ') and ';
                        res += ManufacturerName_filter_added;
                    }
                    if (categories_filter_added) {
                        categoryFilter_detected = true;
                        categories_filter_added = categories_filter_added.trim();
                        res += categories_filter_added;
                    }
                    if (attribute_filter.length > 0) {
                        let in_att = [];
                        attribute_filter.map((value => {
                            in_att.push(` Attributes/any(attribute:attribute/ATTCOMBO eq '${value.attributeName}|#|${value.attributeValue}')     `);
                        }));
                        res += ` ${in_att.join(" and ")} `;
                        addedAtLeaseOneFilter = true;
                    }
                }
                res = res.trim().substring(0, res.length - 4);
            } catch (e) {
            }
        }
        let SboatF = "Sboat eq '" + Auth.getAuthSBoat() + "'";
        if (!addedAtLeaseOneFilter) {
            return {
                res: SboatF,
                categoryFilter_detected,
                appendFacadeOptions_detected,
            };
        }
        res = res.trim();
        if (res) {
            res += " and " + SboatF;
        }
        return {
            res,
            categoryFilter_detected,
            appendFacadeOptions_detected,
        };
    };

    static validateFilterValue = (value) => {
        if (value && (value !== 'string' && value !== 'null')) {
            return value;
        }
        return false;
    };

    static getCognitiveSearchField = (field, value, search_type, selection_single) => {
        if (search_type === 'normal') {
            return field + ' eq' + " '" + value + "' or ";
        }
        if (search_type === 'FamilyName') {
            return field + ' eq' + " '" + value + "' or ";
        }
        if (search_type === 'ManufacturerName') {
            return field + ' eq' + " '" + value + "' or ";
        }
        if (search_type === 'flagFacets') {
            return ProductListingAPICall.getFlagFacetsSearchField(selection_single);
        }
        if (search_type === 'categories') {
            if (selection_single.hidden_payload?.Level !== undefined) {
                let level = selection_single.hidden_payload.Level
                return '(Level_' + level + '_Name eq' + " '" + value + "') and ";
            } else {
                let s = '(Level_1_Name eq' + " '" + value + "' or ";
                s += 'Level_2_Name eq' + " '" + value + "' or ";
                s += 'Level_3_Name eq' + " '" + value + "' or ";
                s += 'Level_4_Name eq' + " '" + value + "') or ";
                s += ')';
                return s;
            }
        }
    };

    static getFlagFacetsSearchField = (value) => {
        if (value.hidden_payload !== undefined) {
            return value.hidden_payload.key + ' eq' + " '" + value.hidden_payload.value + "' and ";
        }
        return false;
    };

    sendCurrentPageEmail = async (reqBody) => {
        __set('SEND_CONTACT_US_EMAIL_API_CALL')
        const config = {
            method: 'post',
            url: Product.PRODUCT_LISTING_SEND_MAIL,
            headers: Helper.getCommonHeader('POST', 'application/json'),
            data: reqBody
        };
        let res = {};
        await axios(config)
            .then(function (response) {
                res = response.data;
            }).catch(() => {
                __remove('SEND_CONTACT_US_EMAIL_API_CALL')
            });
        __remove('SEND_CONTACT_US_EMAIL_API_CALL')
        return res;
    };
    getManufacturersListBySearchParam = async (searchParam = '*') => {
        return await new EssentialContentAPICall().getManufacturersListBySearchParam(searchParam);
    };

    getCategoriesListBySearchParam = async (searchParam = '*') => {
        return await new EssentialContentAPICall().getCategoriesListBySearchParam(searchParam);
    };

    // getNPIListBySearchParam = async (searchParam = '*') => {
    //     return await new EssentialContentAPICall().getNPIListBySearchParam(searchParam);
    // };

    getDocumentsListBySearchParam = async (searchParam = '*') => {
        return await new EssentialContentAPICall().getDocumentsListBySearchParam(searchParam);
    };

    // getArticlesListBySearchParam = async (searchParam = '*') => {
    //     return await new EssentialContentAPICall().getArticlesListBySearchParam(searchParam);
    // };

    // getVideosListBySearchParam = async (searchParam = '*') => {
    //     return await new EssentialContentAPICall().getVideosListBySearchParam(searchParam);
    // };

    // getEventsListBySearchParam = async (searchParam = '*') => {
    //     return await new EssentialContentAPICall().getEventsListBySearchParam(searchParam);
    // };

    // getOtherContentListBySearchParam = async (searchParam = '*') => {
    //     return await new EssentialContentAPICall().getOtherContentListBySearchParam(searchParam);
    // };

    getUniversalProductSearchList = async (searchParam = '*') => {
        let data = {
            "filter": "Sboat eq '" + Auth.getAuthSBoat() + "'",
            "top": 5,
            "skip": 0,
            // "isDesignsRequired": false, // 14567
            "isIncludeCount": true,
            "isProductImageInclude": false,
            "isSkipFacets": true,
            "orderby": "search.score() desc, ERPMFRPartNumber asc",
            "search": searchParam
        };

        const config = {
            method: 'post',
            url: Product.UNIVERSAL_PRODUCT_SEARCH,
            headers: Helper.getCommonHeader('POST', 'application/json'),
            data: data
        };
        let res = {};

        await axios(config)
            .then(function (response) {
                if (response?.data?.Data?.Products && response.data.Data.Products.length > 0) {
                    res = response.data.Data.Products
                }
            }).catch(() => {

            });
        return res
    };

    getUniversalCategoryManufacturersSearchList = async (searchParam = '*') => {
        let data = {
            "filter": "Sboat eq '" + Auth.getAuthSBoat() + "'",
            "top": 5,
            "skip": 0,
            // "isDesignsRequired": false, // 14567
            "isIncludeCount": false,
            "isProductImageInclude": false,
            "isSkipFacets": false,
            "orderby": "ManufacturerPartNumber asc",
            "facetsTypes": ["GlobalSearchManufacturer", "GlobalSearchCategory"],
            "search": searchParam
        };

        const config = {
            method: 'post',
            url: Product.UNIVERSAL_MANUFACTURERS_CATEGORY_SEARCH,
            headers: Helper.getCommonHeader('POST', 'application/json'),
            data: data
        };
        let res = {};

        await axios(config)
            .then(function (response) {
                if (response && response.data && response.data.Data) {
                    res = response.data.Data
                }
            }).catch(() => { });
        res.Categories = new ResponseMaker().processCategories(res.Categories)?.Categories;
        return res;
    };

    static axiosCallToAPI = async (config, isForAutoSuggest, isProductImageInclude) => {
        let res = {};
        __set('PRODUCT_LISTING_API_CALL');
        let axios_config = new PayloadMaker(config, isForAutoSuggest, isProductImageInclude).process().run().get();
        await axios(axios_config)
            .then(function (response) {
                if (response.data.Data !== undefined) {
                    res.data = response.data.Data;
                }
            }).catch(() => {
                __remove('PRODUCT_LISTING_API_CALL');
            });
        let res_made = new ResponseMaker(res).process().run(axios_config, config).get();
        res_made.config = config;
        await storeInUse.dispatch(await set_to_master_data_only_products_list(res_made));
        if (config.p_filter !== undefined && config.p_filter.categoryFilter_detected !== undefined) {
            await storeInUse.dispatch(await set_category_filter_applied_status({
                status: config.p_filter.categoryFilter_detected
            }));
        }
        if (config.p_filter !== undefined && config.p_filter.appendFacadeOptions_detected !== undefined) {
            await storeInUse.dispatch(await set_append_facade_options_status({
                status: config.p_filter.appendFacadeOptions_detected
            }));
        }
        __remove('PRODUCT_LISTING_API_CALL');
        return res_made;
    }

    axiosCall = async (url, data = {}, method = 'get', skipParams = false, isBlob = false, isAllVideo = false) => {
        return await new EssentialContentAPICall().axiosCall(url, data, method, skipParams, isBlob, isAllVideo);
    };
}

export default ProductListingAPICall;